export default __webpack_public_path__ + "static/media/no-image.204765e1.png";